import { takeEvery, fork, put, all, call } from "redux-saga/effects"

//Account JOB Management
import { JOB_COUNT,JOB_SEARCH_COUNT } from "./actionTypes"
import { jobCountSuccessful, jobCountFailed } from "./actions"

import {
  jobSearchCount,jobCount
} from "../../../../../helpers/fakebackend_helper"

//restapi end point
import * as constClass from "../../../../../common/constant/constantURL"

// get JOB list
function * getJobCount({ payload: { user } }) {
  try 
  {
  
    var url;
    let data = JSON.parse(localStorage.getItem("authUser"));
    if(data.userType==="Recruiter")
    {
      
      url=constClass.REST_API_RECRUITER_JOB_COUNT;
    }
    else
    {
      url=constClass.REST_API_GET_JOB_COUNT;
    }
    //calling JOBs count api
    var responsJSON = yield call(jobCount, url);
  
    yield put(jobCountSuccessful(responsJSON))
  } 
  catch (error) 
  {
    yield put(jobCountFailed(error))
  }
}
// get search JOB list
function* getSearchListCount({payload :{user}}) {
  try 
  {
    let data = JSON.parse(localStorage.getItem("authUser"));
    var url;
    if(data.userType==="Recruiter")
    {
      
      url=constClass.REST_API_SEARCH_RECRUITER_JOB_COUNT;
    }
    else
    {
      url=constClass.REST_API_SEARCH_JOB_COUNT;
    }
    //calling JOBs count api
    var responsJSON = yield call(jobSearchCount, url,user);
    yield put(jobCountSuccessful(responsJSON))
  } 
  catch (error) 
  {
    yield put(jobCountFailed(error))
  }
}
export function* watchJobCount() {
  yield takeEvery(JOB_COUNT, getJobCount)
  yield takeEvery(JOB_SEARCH_COUNT, getSearchListCount);
}

function* jobCountSaga() {
  yield all([fork(watchJobCount)])
}

export default jobCountSaga